import {createReducer} from '@reduxjs/toolkit'
import { activateSpinner } from './spinner.action'

export const spinnerActivateReducer = createReducer(false, builder => 
    builder.addCase(activateSpinner, (state, action) => {
        state = action.payload;
        return state;
    })
)